export const commonSelectedStyles = 'emoji-common-selected';
export const selectOnHoverStyles = 'emoji-common-select-on-hover';
export const emojiSprite = 'emoji-common-emoji-sprite';
export const emojiNodeStyles = 'emoji-common-node';
export const emojiImage = 'emoji-common-emoji-image';
export const emojiDeleteButton = 'emoji-common-deleteButton';
export const emojiMainStyle = 'emoji-common-main-styles';
export const deletableEmoji = 'emoji-common-deletable';
export const placeholder = 'emoji-common-placeholder';
export const emojiPickerAddEmoji = 'emoji-picker-add-emoji';
